/* eslint-disable jsx-a11y/img-redundant-alt */
import { Button, Divider, InputNumber } from "antd";
import { convertLegacyProps } from "antd/lib/button/button";
import { parse } from "query-string";
import React, { useCallback } from "react";
import ResultProtractor from "./ResultProtractor";

export default function Protractor(props) {
  
  const [clicked, setClicked] = React.useState(false);
  const [autoPlay, setAutoPlay] = React.useState(true);
  const [getIdResult, setGetIdResult] = React.useState(false)
  const target = React.useRef(null);
  const rotate = React.useRef(0);
  const [hi, setHi] = React.useState(0)
  const resultProtractor = props?.protractor?.[0]?.ResultProtractor || []
  const result = props?.protractor?.[0]?.result || [];
    // const rotateResult = result.map(item=> item.rotate )
  let itemRotate;
  // ================input============================
  let inputLeft = props?.protractor?.[0]?.inputLeft || "unset";
  let inputTop = props?.protractor?.[0]?.inputTop || "unset";
  let inputBottom = props?.protractor?.[0]?.inputBottom || "unset";
  let inputRight = props?.protractor?.[0]?.inputRight || "unset";
  // ================End input============================
 


  // ================cay thước (protractor)=====================================
  React.useEffect(() => {
    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let lastY = 0;
    let dropContainer = document.getElementById("form-container"); // lấy từ T6 Form
    target.current = document.getElementById("protractor"); // lấy hình cần kéo thả từ view page xxx
    

    function onMouseDown(e) {
      setClicked(true);
      setGetIdResult(false)
      startX = e.clientX;
      startY = e.clientY;
      setAutoPlay(true)
      
    }
    
    function onMouseUp(e) {
      setClicked(false);
      let protractorLeft = target.current.offsetLeft;
    let protractorTop = target.current.offsetTop;
    let successPoint = document.getElementById("success-point");
    result.forEach((item) => {
      if (
        item.left - 2 <= protractorLeft &&
        protractorLeft <= item.left + 2 &&
        item.top - 2 <= protractorTop &&
        protractorTop <= item.top + 2
      ) {
        setAutoPlay(true);
        if (autoPlay) {
          successPoint.play();
        }
      }
    });
      lastX = target.current.style.left;
      lastY = target.current.style.top;
    }
    function onMouseMove(e) {
      e.preventDefault();
      // console.log(hello);
      let decreaseLeft = props?.protractor?.[0]?.decreaseLeft || 0;
      let decreaseTop = props?.protractor?.[0]?.decreaseTop || 0;
      let rotateLeftThan0 = props?.protractor?.[0]?.rotateLeftThan0 || 0; // rotate > 0
      let rotateTopThan0 = props?.protractor?.[0]?.rotateTopThan0 || 0; // rotate > 0

      let rotateLeftLess0 = props?.protractor?.[0]?.rotateLeftLess0 || 0; // rotate < 0
      let rotateTopLess0 = props?.protractor?.[0]?.rotateTopLess0 || 0; // rotate < 0
      if (!clicked) return;

      if (lastX === 0) {
        lastX = dropContainer.offsetLeft;
      }
      
      if (lastY === 0) {
        lastY = dropContainer.offsetTop;
      }
      if (rotate.current === 0) {
        target.current.style.left =
          e.clientX + startX - lastX - decreaseLeft + "px";
        target.current.style.top =
          e.clientY + startY - lastY - decreaseTop + "px";
      }
      if (rotate.current > 0) {
        target.current.style.left =
          e.clientX + startX - lastX - decreaseLeft - rotateLeftThan0 + "px";
        target.current.style.top =
          e.clientY + startY - lastY - decreaseTop - rotateTopThan0 + "px";
      }
      if (rotate.current < 0) {
        target.current.style.left =
          e.clientX + startX - lastX - decreaseLeft - rotateLeftLess0 + "px";
        target.current.style.top =
          e.clientY + startY - lastY - decreaseTop - rotateTopLess0 + "px";
      }
    }
    dropContainer.addEventListener("mouseup", onMouseUp);
    dropContainer.addEventListener("mousemove", onMouseMove);
    if (target.current !== null) {
      target.current.addEventListener("mousedown", onMouseDown);
    }
    
    return () => {
      dropContainer.removeEventListener("mousemove", onMouseMove);
      dropContainer.removeEventListener("mouseup", onMouseUp);
      if (target.current !== null) {
        target.current.removeEventListener("mousedown", onMouseDown);
      }
    };
  },);
  
  // ================End cay thước (protractor)=====================================

  // =================xoay thước=========================================
  
  function rotateImage(value ) {
    setGetIdResult(false)
    setAutoPlay(false)
    if ( value <= parseFloat(-180) ){
      rotate.current = value + 360
    } else if(value > 180){
      rotate.current = value - 360
    }
    else{rotate.current = value}
    target.current.style.rotate = `${rotate.current}deg`;
  }
  
  function handleOkButton() {
    setAutoPlay(false)
    let protractorLeft = target.current.offsetLeft;
    let protractorTop = target.current.offsetTop;
    let successAudio = document.getElementById("success-audio");
    let failsAudio = document.getElementById("fails-audio");
    let isSuccess = result.some((item) => {
      return (item.left - 4 <= protractorLeft &&
        protractorLeft <= item.left + 4 &&
        item.top - 4 <= protractorTop &&
        protractorTop <= item.top + 4 &&
        parseFloat(item.rotate - 1) <= parseFloat(rotate.current) &&
        parseFloat(item.rotate + 1) >= parseFloat(rotate.current))
    });
    result.forEach((item) => {
      if (
        item.left - 4 <= protractorLeft &&
        protractorLeft <= item.left + 4 &&
        item.top - 4 <= protractorTop &&
        protractorTop <= item.top + 4 &&
        parseFloat(item.rotate - 1) <= parseFloat(rotate.current) &&
        parseFloat(item.rotate + 1) >= parseFloat(rotate.current)
      ) {
          setHi(item.id)
          setGetIdResult(true)
      }
    });
    isSuccess ? successAudio.play() : failsAudio.play()
  }
  return (
    <>
      <div
        style={{
          position: "absolute",
          left: inputLeft,
          top: inputTop,
          right: inputRight,
          bottom: inputBottom,
          zIndex: 10,
          width: 250,
        }}
      >
        <p>Nhập tọa độ để xoay thước</p>
        <InputNumber 
          min={-360}
          max={360}
          id="input-degree"
          defaultValue={0}
          onChange={rotateImage}
          style={{ width: 100, border: "1px solid black", outline: "none" }}
        />
        <Button
          type="primary"
          style={{ marginLeft: 16, height: 33 }}
          onClick={() => handleOkButton()}
        >
          Xác nhận
        </Button>
        {resultProtractor && getIdResult ? <ResultProtractor  styleResult={resultProtractor[hi]?.styleResult}    textResult={resultProtractor[hi]?.textResult} /> : <React.Fragment />}
        {/* <button onClick={() => rotateImg()}>OK</button> */}
      </div>
      <audio id="success-audio" src="/Audios/page6/success-Sound.mp3" />
      <audio id="fails-audio" src="/Audios/page6/fails.mp3" />
      <audio id="success-point" src="Audios/1.mp3"/>
    </>
  );
}
